type Maybe<T> = T | null | undefined;

export const maybeify =
  <T>(compare: (a: T, b: T) => number, asc: boolean = true) =>
  (a: Maybe<T>, b: Maybe<T>): number => {
    if (a && b) return compare(a, b) * (asc ? 1 : -1);
    if (!a && b) return 1;
    if (a && !b) return -1;
    return 0; // if (!a && !b)
  };

export const anyCompare = (a: any, b: any) => {
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
};

export const numberCompare = (a: number, b: number) => a - b;

export const stringCompare = (
  a: string | undefined | null,
  b: string | undefined | null
) => (a || '').localeCompare(b || '', undefined, { sensitivity: 'base' });

export const dateCompare = (a: Date, b: Date) => a.getTime() - b.getTime();
